module.exports = __webpack_public_path__ + "static/img/016.0ddfda76.jpg";